import validateTime from '../../../../validateTime';

export default class Day {
  weeknum = null;

  open = [];

  close = [];

  active = false;

  openTimeIsValid = true;

  closeTimeIsValid = true;

  periodTime = null;

  constructor(
    weeknum,
    open,
    close,
    active,
    periodTime
    // secondOpen,
    // secondClose
  ) {
    this.weeknum = weeknum;
    this.open = validateTime(open);
    this.close = validateTime(close);
    this.active = !!active;
    this.openTimeIsValid = true;
    this.closeTimeIsValid = true;
    this.periodTime = periodTime;
    // this.secondOpen = secondOpen;
    // this.secondClose = secondClose;
  }

  toJSON() {
    return this;
  }
}
